module.exports = __webpack_public_path__ + "assets/images/51ab9763f2c02767b45f699bf8ff75dd.png";